import { createSelector } from 'reselect'

const selectTopic = (state) => state.trending

const selectTopics = createSelector(selectTopic, (topics) => topics.topics)

const selectTopicsFetching = createSelector(
  selectTopic,
  (topics) => topics.isFetching
)

const selectTrendingDeviceId = createSelector(
  selectTopic,
  (topics) => topics.deviceId
)

export { selectTopics, selectTopicsFetching, selectTrendingDeviceId }
